import { render, staticRenderFns } from "./LinkField.vue?vue&type=template&id=0bdab7f4&"
import script from "./LinkField.vue?vue&type=script&lang=js&"
export * from "./LinkField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports